import { useFormik } from "formik";
import { useEffect, useState } from "react";
import { shallowEqual } from "react-redux";
import styled from "styled-components";
import * as yup from "yup";
import { Input } from "../../../../../../components/Input/input";
import { theme } from "../../../../../../helpers/theme";
import { nipRegExp, phoneRegExp, postalCodeRegExp } from "../../../../../../utils/regex";
import { addressVoivodeshipsList } from "../../../../../../helpers/voievodeshipsList";
import { RequiredInfo } from "../../../../operator-subcontractors-detail-edite/components/forms-wraper/helpers/required-info"; import { useMutation } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { postCheckEmail } from "../../../../../../services/users/check-email";
import { SubcontractorTestValue } from "../../../../operator-subcontractors-add copy/index";
import { Box, Button, InputLabel, MenuItem, Select } from "@mui/material";

interface SubcontractorDataAndAddressAddProps {
    actualInitialSubcontractorAddValue: SubcontractorTestValue;
    addressID: string;
    subcontractorID: string;
    warehouseSubcontractorConnection: boolean,
    backToSummary: boolean;
    setActualInitialSubcontractorAddValue: (value: SubcontractorTestValue) => void;
    setIsNextVisible: (value: boolean) => void;
    setIsBackVisible: (value: boolean) => void;
    setSubcontractorID: (value: string) => void;
    setAddressID: (value: string) => void;
    setActiveStep: (value: number) => void;
    setBackToSummary: (value: boolean) => void;
}

export const SubcontractorDataAndAddressAdd = ({
    actualInitialSubcontractorAddValue,
    addressID,
    subcontractorID,
    warehouseSubcontractorConnection,
    backToSummary,
    setActualInitialSubcontractorAddValue,
    setIsNextVisible,
    setIsBackVisible,
    setSubcontractorID,
    setAddressID,
    setActiveStep,
    setBackToSummary,
}: SubcontractorDataAndAddressAddProps) => {


    const [isDataChange, setIsDataChange] = useState(false);
    const [whetherTheEmailExistsInTheDatabase, setWhetherTheEmailExistsInTheDatabase] = useState(false);
    const validationSchema = yup.object({
        nazwa_wykonawcy: yup
            .string()
            .strict()
            .required("Nazwa firmy jest wymagana")
            .max(50, "Maksymalnie 50 znaków"),
        nip: yup
            .string()
            .required("NIP jest wymagany")
            .matches(nipRegExp, "Błędny format!")
            .min(10, "Błędny format!")
            .max(10, "Błędny format!"),
        telefon: yup
            .string()
            .required("Telefon jest wymagany")
            .matches(phoneRegExp, "Błędny format!")
            .min(9, "Błędny format!")
            .max(9, "Błędny format!"),
        email: yup
            .string()
            .required("E-mail jest wymagany")
            .email("Błędny format adresu E-mail")
            .max(50, "Maksymalnie 50 znaków"),
        miejscowosc: yup
            .string()
            .strict()
            .required("Miejscowość jest wymagana")
            .max(100, "Maksymalnie 100 znaków"),
        kod_pocztowy: yup
            .string()
            .required("Kod pocztowy jest wymagany")
            .matches(postalCodeRegExp, "Błędny format!")
            .min(6, "Błędny format!")
            .max(6, "Błędny format!"),
        ulica: yup
            .string()
            .strict()
            //.required("Ulica jest wymagana")
            .max(100, "Maksymalnie 100 znaków"),
        numer_budynku: yup
            .string()
            .strict()
            .required("Numer budynku jest wymagany")
            .max(5, "Maksymalnie 5 znaków"),
        numer_lokalu: yup
            .number()
            .min(1, "Minimalna wartość to 1")
            .max(99999, "Maksymalna wartość to 99999")
            .typeError("Numer lokalu od 1 do 99999"),
        wojewodztwo: yup
            .string()
            .strict()
            .required("Województwo jest wymagane")
            .max(50, "Maksymalnie 50 znaków"),
        kraj: yup
            .string()
            .strict()
            .max(70, "Maksymalnie 70 znaków"),

    });

    const handleGoToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
    }

    const postCheckEmailMutation = useMutation(postCheckEmail, {
        onSuccess: (res) => {
            setWhetherTheEmailExistsInTheDatabase(false);
        },
        onError: (error: AxiosError) => {
            if (error.response?.request.status === 400) {
                setWhetherTheEmailExistsInTheDatabase(true);
            } else {
            }
        },
    });


    const formik = useFormik({
        initialValues: {
            nazwa_wykonawcy: actualInitialSubcontractorAddValue.nazwa_wykonawcy,
            nip: actualInitialSubcontractorAddValue.nip,
            telefon: actualInitialSubcontractorAddValue.telefon,
            email: actualInitialSubcontractorAddValue.email,
            kod_pocztowy: actualInitialSubcontractorAddValue.kod_pocztowy,
            miejscowosc_poczty: actualInitialSubcontractorAddValue.miejscowosc_poczty,
            miejscowosc: actualInitialSubcontractorAddValue.miejscowosc,
            ulica: actualInitialSubcontractorAddValue.ulica,
            numer_budynku: actualInitialSubcontractorAddValue.numer_budynku,
            numer_lokalu: actualInitialSubcontractorAddValue.numer_lokalu,
            wojewodztwo: actualInitialSubcontractorAddValue.wojewodztwo,
            kraj: actualInitialSubcontractorAddValue.kraj,
        },
        validationSchema: validationSchema,
        onSubmit: (values: SubcontractorTestValue) => {

            const subcontractor_data_body = {
                nazwa_wykonawcy: values.nazwa_wykonawcy,
                nip: values.nip,
                telefon: values.telefon,
                email: values.email,
                adres_id: addressID,
            }

            const subcontracor_address_body = {
                kod_pocztowy: formik.values.kod_pocztowy,
                miejscowosc_poczty: formik.values.kod_pocztowy,
                miejscowosc: formik.values.miejscowosc,
                ulica: formik.values.ulica,
                numer_budynku: formik.values.numer_budynku,
                numer_lokalu: formik.values?.numer_lokalu ? formik.values?.numer_lokalu : null,
                wojewodztwo: formik.values.wojewodztwo,
                kraj: formik.values.kraj,
            }

            if (isDataChange) {
                //postNewSubcontractorAddMutation.mutate(body)
                setActualInitialSubcontractorAddValue({
                    nazwa_wykonawcy: formik.values.nazwa_wykonawcy,
                    nip: formik.values.nip,
                    telefon: formik.values.telefon,
                    email: formik.values.email,

                    kod_pocztowy: formik.values.kod_pocztowy,
                    miejscowosc_poczty: formik.values.miejscowosc_poczty,
                    miejscowosc: formik.values.miejscowosc,
                    ulica: formik.values.ulica,
                    numer_budynku: formik.values.numer_budynku,
                    numer_lokalu: formik.values.numer_lokalu,
                    wojewodztwo: formik.values.wojewodztwo,
                    kraj: formik.values.kraj,
                });

                setIsDataChange(false);
                backToSummary ? setActiveStep(2) : setActiveStep(1);
                setBackToSummary(false);
                handleGoToTop();

            }
        },
    });

    const compareValuesInFormWithStartedValues = (
        values: SubcontractorTestValue,
        newValues: SubcontractorTestValue) => {
        return !shallowEqual(values, newValues);
    };


    useEffect(() => {

        setIsDataChange(compareValuesInFormWithStartedValues(actualInitialSubcontractorAddValue, {
            nazwa_wykonawcy: formik.values.nazwa_wykonawcy,
            nip: formik.values.nip,
            telefon: formik.values.telefon,
            email: formik.values.email,

            kod_pocztowy: formik.values.kod_pocztowy,
            miejscowosc_poczty: formik.values.miejscowosc_poczty,
            miejscowosc: formik.values.miejscowosc,
            ulica: formik.values.ulica,
            numer_budynku: formik.values.numer_budynku,
            numer_lokalu: formik.values.numer_lokalu,
            wojewodztwo: formik.values.wojewodztwo,
            kraj: formik.values.kraj,
        }));
    }, [formik.values]);

    useEffect(() => {
    }, [backToSummary]);

    const isEmailexists = (email: string, rola: number|null) => {
        if (email !== "") {
            postCheckEmailMutation.mutate({
                email: email,
                rola: null,
            })
        }
    }

    return (
        <Container>
            <form
                onSubmit={formik.handleSubmit}
                onChange={() => setIsDataChange(compareValuesInFormWithStartedValues(actualInitialSubcontractorAddValue, {
                    nazwa_wykonawcy: formik.values.nazwa_wykonawcy,
                    nip: formik.values.nip,
                    telefon: formik.values.telefon,
                    email: formik.values.email,

                    kod_pocztowy: formik.values.kod_pocztowy,
                    miejscowosc_poczty: formik.values.miejscowosc_poczty,
                    miejscowosc: formik.values.miejscowosc,
                    ulica: formik.values.ulica,
                    numer_budynku: formik.values.numer_budynku,
                    numer_lokalu: formik.values.numer_lokalu,
                    wojewodztwo: formik.values.wojewodztwo,
                    kraj: formik.values.kraj,
                }))}
            >
                <Title>Podwykonawca:</Title>
                <SumamryWraper key="Nazwa">
                    <SummaryItemValue>
                        <Input
                            label="Nazwa*"
                            id="nazwa_wykonawcy"
                            name="nazwa_wykonawcy"
                            value={formik.values.nazwa_wykonawcy}
                            onChange={formik.handleChange}
                            error={formik.touched.nazwa_wykonawcy && Boolean(formik.errors.nazwa_wykonawcy)}
                            helperText={formik.touched.nazwa_wykonawcy && formik.errors.nazwa_wykonawcy}
                            onBlur={formik.handleBlur}
                            variant="filled"
                            disabled={warehouseSubcontractorConnection}
                            sx={{
                                width: "100%",
                                textOverflow: "ellipsis",
                                "& .MuiInputBase-root.Mui-disabled": {
                                    backgroundColor: `${theme.colors.gray05_input}`,
                                }
                            }}
                        />
                    </SummaryItemValue>
                </SumamryWraper >
                <SumamryWraper key="NIP">
                    <SummaryItemValue>
                        <Input
                            label="NIP*"
                            id="nip"
                            name="nip"
                            value={formik.values.nip}
                            onChange={formik.handleChange}
                            error={formik.touched.nip && Boolean(formik.errors.nip)}
                            helperText={formik.touched.nip && formik.errors.nip}
                            onBlur={formik.handleBlur}
                            variant="filled"
                            disabled={warehouseSubcontractorConnection}
                            sx={{
                                width: "100%",
                                textOverflow: "ellipsis",
                                "& .MuiInputBase-root.Mui-disabled": {
                                    backgroundColor: `${theme.colors.gray05_input}`,
                                }
                            }}
                        />
                    </SummaryItemValue>
                </SumamryWraper>
                <SumamryWraper key="Telefon">
                    <SummaryItemValue>
                        <Input
                            label="Telefon*"
                            id="telefon"
                            name="telefon"
                            value={formik.values.telefon}
                            onChange={formik.handleChange}
                            error={formik.touched.telefon && Boolean(formik.errors.telefon)}
                            helperText={formik.touched.telefon && formik.errors.telefon}
                            onBlur={formik.handleBlur}
                            variant="filled"
                            disabled={warehouseSubcontractorConnection}
                            sx={{
                                width: "100%",
                                textOverflow: "ellipsis",
                                "& .MuiInputBase-root.Mui-disabled": {
                                    backgroundColor: `${theme.colors.gray05_input}`,
                                }
                            }}
                        />
                    </SummaryItemValue>
                </SumamryWraper>
                <SumamryWraper key="E-mail">
                    <SummaryItemValue>
                        <Input
                            label="E-mail*"
                            id="email"
                            name="email"
                            value={formik.values.email}
                            onChange={formik.handleChange}
                            error={formik.touched.email && Boolean(formik.errors.email)}
                            helperText={formik.touched.email
                                && formik.errors.email}
                            onBlur={formik.handleBlur}
                            onBlurCapture={() => isEmailexists(formik.values.email, 1)}


                            variant="filled"
                            disabled={warehouseSubcontractorConnection}
                            sx={{
                                width: "100%",
                                textOverflow: "ellipsis",
                                "& .MuiInputBase-root.Mui-disabled": {
                                    backgroundColor: `${theme.colors.gray05_input}`,
                                }
                            }}
                        />
                        {formik.values.email !== "" && !formik.errors.email
                            ? <ErrorMessage>
                                {whetherTheEmailExistsInTheDatabase
                                    ? "Powyższy e-mail jest już w bazie"
                                    : ""}
                            </ErrorMessage>
                            : null
                        }

                    </SummaryItemValue>
                </SumamryWraper>
                <Title>Adres wykonawcy</Title>
                <SumamryWraper key="Kod pocztowy">
                    <SummaryItemValue>
                        <Input
                            label="Kod pocztowy*"
                            id="kod_pocztowy"
                            name="kod_pocztowy"
                            value={formik.values.kod_pocztowy}
                            onChange={formik.handleChange}
                            error={formik.touched.kod_pocztowy && Boolean(formik.errors.kod_pocztowy)}
                            helperText={formik.touched.kod_pocztowy && formik.errors.kod_pocztowy}
                            onBlur={formik.handleBlur}
                            variant="filled"
                            disabled={warehouseSubcontractorConnection}
                            sx={{
                                width: "100%",
                                textOverflow: "ellipsis",
                                "& .MuiInputBase-root.Mui-disabled": {
                                    backgroundColor: `${theme.colors.gray05_input}`,
                                }
                            }}
                        />
                    </SummaryItemValue>
                </SumamryWraper>
                <SumamryWraper key="Miejscowość">
                    <SummaryItemValue>
                        <Input
                            label="Miejscowość*"
                            id="miejscowosc"
                            name="miejscowosc"
                            value={formik.values.miejscowosc}
                            onChange={formik.handleChange}
                            error={formik.touched.miejscowosc && Boolean(formik.errors.miejscowosc)}
                            helperText={formik.touched.miejscowosc && formik.errors.miejscowosc}
                            onBlur={formik.handleBlur}
                            variant="filled"
                            disabled={warehouseSubcontractorConnection}
                            sx={{
                                width: "100%",
                                textOverflow: "ellipsis",
                                "& .MuiInputBase-root.Mui-disabled": {
                                    backgroundColor: `${theme.colors.gray05_input}`,
                                }
                            }}
                        />
                    </SummaryItemValue>
                </SumamryWraper>
                <SumamryWraper key="Ulica">
                    <SummaryItemValue>
                        <Input
                            label="Ulica"
                            id="ulica"
                            name="ulica"
                            value={formik.values.ulica}
                            onChange={formik.handleChange}
                            error={formik.touched.ulica && Boolean(formik.errors.ulica)}
                            helperText={formik.touched.ulica && formik.errors.ulica}
                            onBlur={formik.handleBlur}
                            variant="filled"
                            disabled={warehouseSubcontractorConnection}
                            sx={{
                                width: "100%",
                                textOverflow: "ellipsis",
                                "& .MuiInputBase-root.Mui-disabled": {
                                    backgroundColor: `${theme.colors.gray05_input}`,
                                }
                            }}
                        />
                    </SummaryItemValue>
                </SumamryWraper>
                <SumamryWraper key="Numer budynku">
                    <SummaryItemValue>
                        <Input
                            label="Numer budynku*"
                            id="numer_budynku"
                            name="numer_budynku"
                            value={formik.values.numer_budynku}
                            onChange={formik.handleChange}
                            error={formik.touched.numer_budynku && Boolean(formik.errors.numer_budynku)}
                            helperText={formik.touched.numer_budynku && formik.errors.numer_budynku}
                            onBlur={formik.handleBlur}
                            variant="filled"
                            disabled={warehouseSubcontractorConnection}
                            sx={{
                                width: "100%",
                                textOverflow: "ellipsis",
                                "& .MuiInputBase-root.Mui-disabled": {
                                    backgroundColor: `${theme.colors.gray05_input}`,
                                }
                            }}
                        />
                    </SummaryItemValue>
                </SumamryWraper>
                <SumamryWraper key="Numer lokalu">
                    <SummaryItemValue>
                        <Input
                            label="Numer lokalu"
                            id="numer_lokalu"
                            name="numer_lokalu"
                            value={formik.values.numer_lokalu}
                            onChange={formik.handleChange}
                            error={formik.touched.numer_lokalu && Boolean(formik.errors.numer_lokalu)}
                            helperText={formik.touched.numer_lokalu && formik.errors.numer_lokalu}
                            onBlur={formik.handleBlur}
                            variant="filled"
                            disabled={warehouseSubcontractorConnection}
                            sx={{
                                width: "100%",
                                textOverflow: "ellipsis",
                                "& .MuiInputBase-root.Mui-disabled": {
                                    backgroundColor: `${theme.colors.gray05_input}`,
                                }
                            }}
                        />
                    </SummaryItemValue>
                </SumamryWraper>
                <SumamryWraper
                    style={{ marginTop: "-18px" }}
                    key="Województwo">
                    <SummaryItemValue>
                        <InputLabel sx={{
                            color: `${warehouseSubcontractorConnection
                                ? "00000061"
                                : theme.colors.gray01_secondaryText}`,
                            fontSize: "12px",
                            font: `${theme.fonts.interRegular}`,
                            top: "25px",
                            left: "12px",
                            zIndex: "1000",


                        }}
                        >Województwo*</InputLabel>
                        <Select
                            id="wojewodztwo"
                            name="wojewodztwo"
                            value={formik.values.wojewodztwo}
                            label="Województwo"
                            onChange={formik.handleChange}
                            variant="filled"
                            disabled={warehouseSubcontractorConnection}
                            disableUnderline //usuwa podkreslenie
                            sx={{
                                width: "100%",
                                backgroundColor: "#fcfcfb",
                                borderRadius: "8px",
                                "& .Mui-disabled": {
                                    backgroundColor: `${theme.colors.gray05_input}`,
                                    borderRadius: "8px",
                                }
                            }}
                        >

                            {addressVoivodeshipsList.map((item) => (
                                <MenuItem key={item} value={item}>
                                    {item}
                                </MenuItem>
                            ))}
                        </Select>
                    </SummaryItemValue>
                </SumamryWraper>
                <SumamryWraper key="Kraj">
                    <SummaryItemValue>
                        <Input
                            label="Kraj"
                            id="krajl"
                            name="kraj"
                            value={formik.values.kraj}
                            onChange={formik.handleChange}
                            error={formik.touched.kraj && Boolean(formik.errors.kraj)}
                            helperText={formik.touched.kraj && formik.errors.kraj}
                            onBlur={formik.handleBlur}
                            variant="filled"
                            disabled

                            sx={{
                                width: "100%",
                                textOverflow: "ellipsis",
                                "& .MuiInputBase-root.Mui-disabled": {
                                    backgroundColor: `${theme.colors.gray05_input}`,
                                }
                            }}
                            // InputProps={{
                            //     readOnly: true,
                            // }}
                        />
                    </SummaryItemValue>
                </SumamryWraper>
                <RequiredInfo text={"Pola obowiązkowe"} />

                <Box sx={{ display: 'flex', flexDirection: 'row', pt: 2 }}>

                    <Box sx={{ flex: '1 1 auto' }} />
                    {backToSummary
                        ?
                        <Button
                            onClick={() => { setActiveStep(2); setBackToSummary(false); handleGoToTop(); }}
                            sx={{
                                color: `${theme.colors.blue02_hover}`,
                                ":hover": {
                                    color: `${theme.colors.white}`,
                                    bgcolor: `${theme.colors.blue02_hover}`,
                                },
                            }}
                        >
                            Powrót do podsumowania
                        </Button>
                        :
                        <></>
                    }
                    <Button
                        type="submit"
                        disabled={
                            !formik.isValid ||
                            !isDataChange ||
                            whetherTheEmailExistsInTheDatabase ||
                            postCheckEmailMutation.isLoading

                        }
                        sx={{
                            color: `${theme.colors.blue02_hover}`,
                            ":disabled": {
                                color: `#00000061`,
                            },
                            ":hover": {
                                color: `${theme.colors.white}`,
                                bgcolor: `${theme.colors.blue02_hover}`,
                            },
                        }}

                    >
                        {backToSummary ? "Zachowaj zmiany" : "Dalej"}
                    </Button>
                </Box>


            </form >

        </Container >
    );
};
const Container = styled.div`
width:100%;
font-family:${theme.fonts.interMedium},

`;
const SumamryWraper = styled.div`
display: flex;
flex-direction: column;
width: 100%;
`;

const SummaryItemValue = styled.div`
padding: 5px 0px;
font-family: ${theme.fonts.interRegular};
font-style: normal;
font-weight: ${theme.fontWeight.small};
font-size: 14px;
line-height: 20px;
color: ${theme.colors.gray01_secondaryText};
overflow-wrap: break-word;
align-content: center;
white-space: break-spaces;
`;

const ButtonWraper = styled.div`
width:100%;
text-align:center;`


const Title = styled.div`
font-family: ${theme.fonts.interMedium};
font-size: 18px;
line-height: 20px;
margin-bottom:10px;
font-weight: ${theme.fontWeight.big};
padding-top:32px;
`;
const NextButton = styled.div<{
    isDisable: boolean;
}>`
color: ${(props: any) => (props.isDisable
        ? `${theme.colors.blue01_active} `
        : "#00000061")};
`;
const ErrorMessage = styled.div`
color:#d32f2f;
font-family: "Roboto","Helvetica","Arial",sans-serif;
font-weight: 400;
font-size: 0.75rem;
line-height: 1.66;
letter-spacing: 0.03333em;
text-align: left;
margin-top: 3px;
margin-right: 14px;
margin-bottom: 0;
margin-left: 14px;
`;





